import { render, staticRenderFns } from "./SsComponentPage.vue?vue&type=template&id=ac242d04&scoped=true"
import script from "./SsComponentPage.vue?vue&type=script&lang=ts"
export * from "./SsComponentPage.vue?vue&type=script&lang=ts"
import style0 from "./SsComponentPage.vue?vue&type=style&index=0&id=ac242d04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac242d04",
  null
  
)

export default component.exports